/**
 * GraphQL queries and subscriptions for RolePermission
 */

export const LIST_ROLE_PERMISSIONS = /* GraphQL */ `
    query ListRolePermissions($limit: Int, $nextToken: String) {
        listRolePermissions(limit: $limit, nextToken: $nextToken) {
            items {
                id
                ownerId
                roleId
                workspaceId
                objectType
                objectId
                createdAt
                createdBy
            }
            nextToken
        }
    }
`;

export const onCreateRolePermission = /* GraphQL */ `
    subscription OnCreateRolePermission($ownerId: String) {
        onCreateRolePermission(ownerId: $ownerId) {
            id
            ownerId
            roleId
            workspaceId
            objectType
            objectId
            createdAt
            createdBy
        }
    }
`;

export const onUpdateRolePermission = /* GraphQL */ `
    subscription OnUpdateRolePermission($ownerId: String) {
        onUpdateRolePermission(ownerId: $ownerId) {
            id
            ownerId
            roleId
            workspaceId
            objectType
            objectId
            createdAt
            createdBy
        }
    }
`;

export const onDeleteRolePermission = /* GraphQL */ `
    subscription OnDeleteRolePermission($ownerId: String) {
        onDeleteRolePermission(ownerId: $ownerId) {
            id
            ownerId
            roleId
            workspaceId
            objectType
            objectId
            createdAt
            createdBy
        }
    }
`;
